
import { observable, action, autorun, computed, toJS } from 'mobx'
import http from 'src/helper/http'
import cdn from 'src/helper/cdn'

export default class {
  @observable data = {
    cd: 0,
    userList: [],
    roomList: []
  }

  // 倒计时
  @action async getCd(data) {
    let res = await http.post('/web/nationalday/count/down', data)
    if (res && res.code == 0) {
      return res.res
    }
  }
  // 用户列表    type：1国家 2世界
  @action async getUserList(data) {
    let res = await http.post('/web/nationalday/rank/user', data)
    if (res && res.code == 0) {
      return res.res
    }
  }
  // 房间列表
  @action async getRoomList(data) {
    let res = await http.post('/web/nationalday/rank/group', data)
    if (res && res.code == 0) {
      return res.res
    }
  }

  // 礼物列表
  @action async getGiftList(data) {
    let res = await http.post('/web/nationalday/gift', data)
    if (res && res.code == 0) {
      return res.res
    }
  }

  // 奖励列表
  @action async getReward(data) {
    let res = await http.post('/web/nationalday/reward', data)
    if (res && res.code == 0) {
      return res.res
    }
  }

  // 配置
  @action async getConfig(data) {
    let res = await http.post('/web/nationalday/conf', data)
    if (res && res.code == 0) {
      return res.res
    }
  }
}



// WEBPACK FOOTER //
// src/store/activity/nationalTemplate.js